import React from 'react'
import { Card } from 'react-bootstrap';
import HeroImagesScroller from './HeroImagesScroller';
function HeroImagesScrollerMain() {
  return (
    <>
    <Card className="h-100 mt-3">
      <Card.Header className="bg-light btn-reveal-trigger d-flex flex-between-center">
        <h5 className="mb-0">Hero Images Scroller</h5>
      </Card.Header>
      <Card.Body>
        <HeroImagesScroller />
      </Card.Body>
    </Card>
  </>
  )
}

export default HeroImagesScrollerMain